module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/features/cards/cards-style7/cards-style7.component.scss
// module id = ./src/app/features/cards/cards-style7/cards-style7.component.scss
// module chunks = main